<script setup>
import Content from "@/components/Content/Content.vue";
import Rolling from "@/pages/Index/components/Rolling.vue";
import {computed} from "vue";

const props = defineProps({
	customer: {
		type: Array,
		default: () => []
	}
})

const customerLogo = computed(() => props.customer.map(item => item.image))
const line1 = computed(() => customerLogo.value)
const line2 = computed(() => customerLogo.value.slice().reverse())
const line3 = computed(() => shuffleArray(customerLogo.value))
function shuffleArray(array) {
	const shuffled = array.slice(); // 复制数组
	for (let i = shuffled.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
	}
	return shuffled;
}

</script>

<template>
	<div class="customer">
		<div class="customer__content">
			<Content
				:title="$t('section.partner.title')"
				mode="dark"
			>
				<div class="customer__content__list">
					<div class="customer__content__list__overlay">
						<div class="overlay__left overlay" />
						<div class="overlay__right overlay" />
					</div>
					<div class="customer__content__rolling">
						<Rolling
							:list="line1"
						/>
					</div>
					
					<div class="customer__content__rolling">
						<Rolling
							:list="line2"
							direction="right-to-left"
						/>
					</div>
					
<!--					<div class="customer__content__rolling">-->
<!--						<Rolling-->
<!--							:list="line3"-->
<!--						/>-->
<!--					</div>-->
				</div>
			</Content>
		</div>
	</div>
</template>

<style scoped lang="less">
.customer {
	background-image: url("~@/assets/images/bg/customer.png");
	background-size: cover;
	background-repeat: no-repeat;
	&__content {
		padding: 72px 0;
		
		&__rolling {
			margin-bottom: 30px;
			padding: 0 10px;
			
			&:last-child {
				margin-bottom: 0;
			}
		}
		
		&__list {
			position: relative;
			overflow: hidden;
			&__overlay {
				position: absolute;
				width: 100%;
				height: 100%;
				z-index: 9;
				display: flex;
				justify-content: space-between;
				
				.overlay {
					width: 15%;
					height: 100%;
					//background: #fff;
					background-size: 100% 100%;
					background-repeat: no-repeat;
					filter: drop-shadow(10px 0 20px rgba(255, 255, 255, 1));
					&__left {
						background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
					}
					
					&__right {
						background: linear-gradient(270deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
					}
					
				}
			}
		}
	}
}

@media only screen and (max-width: 768px) {
	.customer {
		&__content {
			padding: 30px 0;
			
			&__rolling {
				margin-bottom: 15px;
				padding: 0 10px;
				
				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}
}
</style>